<template>
	<div>
		<table class="table table-bordered">
			<tr>
				<td>No.</td>
				<td>Jumlah Min.</td>
				<td>Jumlah Maks.</td>
				<td>Diskon</td>
				<td>Harga Satuan <i class="material-icons info" v-tooltip="'Harga Satuan = Harga Coret - (Harga Coret x Diskon)'">info</i></td>
				<td>Aksi</td>
			</tr>
			<tr v-for="(item, idx) in distributorWholesale" :key="idx">
				<td>Harga Distributor {{ idx+1 }}</td>
				<td>
					<input type="number" class="form-control" :id="`min-${idx}`" min="1" max="999999" v-model="item.min" readonly @input="update">
					<small class="text-danger" v-if="errors.min[idx]">{{ errors.min[idx] }}</small>
				</td>
				<td>
					<input type="number" class="form-control" :id="`max-${idx}`" max="999999" v-model="item.max" :data-index="idx" @blur="onInputMax" @input="update">
					<small class="text-danger" v-if="errors.max[idx]">{{ errors.max[idx] }}</small>
				</td>
				<td>
					<div class="input-group">
						<input type="number" class="form-control" :id="`discount-${idx}`" max="99" v-model="item.discount" :data-index="idx" @blur="onInputDiscount" @input="update">
						<div class="input-group-append">
							<span class="input-group-text">%</span>
						</div>
					</div>
					<small class="text-danger" v-if="errors.discount[idx]">{{ errors.discount[idx] }}</small>
				</td>
				<td>
					<input type="text" class="form-control" :id="`price-${idx}`" :value="formatMoney(item.price)" readonly>
					<small class="text-danger" v-if="errors.price[idx]">{{ errors.price[idx] }}</small>
				</td>
				<td>
					<button class="btn btn-sm btn-outline-danger" @click="deleteRow(idx)" :disabled="idx !== (distributorWholesale.length - 1)">
						<i class="bi bi-trash"></i>
					</button>
				</td>
			</tr>
			<tr>
				<td>Harga Distributor {{ distributorWholesale.length + 1 }}</td>
				<td colspan="5">
					<button class="btn btn-sm btn-outline-primary" @click="addRow" :disabled="isDisabled">
						<i class="bi bi-plus"></i> Tambah Harga Distributor
					</button>
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { duplicateVar, formatMoney } from '@/lib/helper';

export default {
	props: {
		wholesale: {
			type: Array,
			default: () => [],
		},
		slashPrice: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			firstItem: {
				min: 1,
				max: null,
				discount: null,
				price: null,
			},
			distributorWholesale: [],
		};
	},
	methods: {
		...mapActions({
			resetStepErrors: 'productCreator/resetStepErrors',
		}),
		formatMoney,
		validateLimit(value, type = 'quantity') {
			if (value < 1) {
				value = 1;
			} else if (value > 999999 && type === 'quantity') {
				value = 999999;
			} else if (value > 99 && type === 'discount') {
				value = 99;
			}
			return value;
		},
		forceUpdate() {
			const updatedDistributorWholesale = this.distributorWholesale.map((item) => {
				const min = this.validateLimit(Number(item.min));
				const max = this.validateLimit(Number(item.max));
				const discount = this.validateLimit(Number(item.discount), 'discount');
				const price = Number(item.price);

				const validatedItem = {
					min,
					max,
					discount,
					price,
				};
				return validatedItem;
			});
			this.distributorWholesale = updatedDistributorWholesale;
		},
		update() {
			setTimeout(() => {
				this.forceUpdate();
			}, 1000);
			this.resetStepErrors();
			this.$emit('update', this.distributorWholesale);
		},
		onInputDiscount(event) {
			const index = event.target.dataset.index;
			const discount = event.target.value;
			let priceAfterDiscount = this.slashPrice - Math.ceil(this.slashPrice * (discount / 100));
			priceAfterDiscount = Number(priceAfterDiscount) < 0 ? 0 : priceAfterDiscount;
			this.distributorWholesale[index].price = priceAfterDiscount;
			this.update();
		},
		onInputMax(event) {
			const index = event.target.dataset.index;
			const nextIndex = Number(index) + 1;
			const max = event.target.value;

			if (this.distributorWholesale.at(nextIndex)) {
				const nextWholesale = this.distributorWholesale.at(nextIndex);
				nextWholesale.min = Number(max) + 1;
				this.distributorWholesale[nextIndex] = nextWholesale;
				this.update();
			}
		},
		addRow() {
			const lastWholesale = this.distributorWholesale.at(-1);
			const newItem = {
				min: Number(lastWholesale.max) + 1,
				max: null,
				discount: null,
				price: 0,
			};
			this.distributorWholesale.push(newItem);
		},
		deleteRow(index) {
			this.distributorWholesale = this.distributorWholesale.filter((item, idx) => Number(idx) !== Number(index));
			this.update();
		},
		initDistributorWholesale() {
			this.distributorWholesale = duplicateVar(this.wholesale);
			if (this.distributorWholesale?.length <= 0) {
				this.distributorWholesale.push(this.firstItem);
			}
		},
	},
	computed: {
		...mapGetters({
			stepErrors: 'productCreator/stepErrors',
		}),
		errors() {
			const initErrors = {
				min: [],
				max: [],
				discount: [],
				price: [],
			};

			const currentStepErrors = this.stepErrors('product');
			const distributorWholesaleErrors = currentStepErrors?.distributor_wholesale;
			initErrors.min = distributorWholesaleErrors?.min ?? [];
			initErrors.max = distributorWholesaleErrors?.max ?? [];
			initErrors.discount = distributorWholesaleErrors?.discount ?? [];
			initErrors.price = distributorWholesaleErrors?.price ?? [];

			return initErrors;
		},
		isDisabled() {
			const lastWholesale = this.distributorWholesale.at(-1);
			return lastWholesale?.min === null || lastWholesale?.max === null || lastWholesale?.discount === null;
		},
	},
	watch: {
		wholesale() {
			this.initDistributorWholesale();
		},
	},
	mounted() {
		this.initDistributorWholesale();
	},
};
</script>
